import React from 'react';

import HeaderInfo from '../../components/HeaderInfo/HeaderInfo';
import { Filters } from "../../modules/Filters";
import { ApartmentsList } from '../../modules/ApartmentsList';

const ParametersChooserPage = () => {
    const complexName = document.querySelector( 'section.chooser' )?.getAttribute( 'data-complex-name' );
    
	return (
		<>
			<HeaderInfo object={complexName} isVisual={false} />
			<Filters />
			<ApartmentsList />
		</>
	)
};

export default ParametersChooserPage;
